import React, {useState, useEffect}from 'react';
import './style.css';
import {Form, TextArea, Button, Loader, Dimmer} from 'semantic-ui-react'
import { useSelector } from 'react-redux';

import WhatsappIcon from "../../icons/whatsapp-icon.png";
import {putTicket} from "../../components/UserLogin/actions";
import translations from "../../components/LanguageModal/translations";
import {getLanguage} from "../../components/LanguageModal/reducer";
import {isOnline} from "../../components/WindowDimensions";
import {getTypeExhibition} from "../Home/reducer";

export default function Support(props) {
    const {dispatch, token, mixpanel, previousLocations} = props;
    const userData = useSelector(state => state.userLogin.userData);
    const [isLoading, setIsLoading] = useState(false);
    const [userName, setUserName] = useState('');
    const [userPhone, setUserPhone] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [messageValue, setMessageValue] = useState('');

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));

    // console.log(previousLocations[2]?.location?.pathname?.startsWith('/gras'))

    useEffect(() => {
        setUserName(userData.billing.first_name + ' ' + userData.billing.last_name);
        setUserPhone(userData.billing.phone);
        setUserEmail(userData.billing.email);
        window.scrollTo(0, 0);
        if (mixpanel) {
            mixpanel.track('View. Support')
        }
    }, []);

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    const handleChange = (e, {value}) => {
        setMessageValue(value);
    }

    const handleSubmit = () => {

        if (!isOnline(true, languageString)) {

        } else {
            dispatch(putTicket(token, 'Вопрос пользователя', messageValue, userName, 'support@asiaexpo.space', userEmail, userPhone, languageString))
            setMessageValue('');
            if (mixpanel) {
                mixpanel.track('Action. Send question')
            }
        }


    }

    return (
        <div className="support-view">
            <div className="support-text">{!previousLocations[2]?.location?.pathname?.startsWith('/gras') ? t("askQuestion") : t("askQuestionGras") }</div>
            {!previousLocations[2]?.location?.pathname?.startsWith('/gras') ?
                <a href=" https://wa.me/79094474166"><img src={WhatsappIcon} className="support-icon"/></a>
                : ( <div style={{'display': 'flex', 'justifyContent': 'space-around', 'alignItems': 'center', gap: '10px', marginBottom: '10px'}} >
                        <a href='tel:+966112074854'>+ 966 11 207 4854</a>
                        <div>или</div>
                        <a href='tel:+966553136777'>+ 966 55 313 6777</a>
                    </div>
                )

            }
            <div className="support-text">{t("writeUsMail")}</div>
            <Form className="support-form" >
                <TextArea type="text" placeholder={t("urQuestion")} value={messageValue} onChange={handleChange} className="support-text-area" transparent/>
            </Form>
            <Button className={`support-btn ${typeExhibition}`} onClick={handleSubmit}> {t("send")} </Button>
            <Dimmer active={isLoading} inverted>
                <Loader active={isLoading}>{t("sendingMessage")}...</Loader>
            </Dimmer>
        </div>

    )

}
